import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroupDirective, Validators,} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {isArtisant, isEntrpriseEtrangere, isGroupeArtisant, isPersonnemorale, isPersonnePhysique,} from 'src/app/domain/categorie/common';
import {EtatService} from 'src/app/modules/services/etat-demande/etat.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {icons} from 'src/app/ui/icons';
import {CommmCode} from 'src/app/utils/constante/CommonCode';
import {isEmpty} from 'src/app/utils/is-empty';
import {InscriptionfournisseurFormService} from '../fournisseur/inscriptionfournisseur-form.service';
import {ExportReportsBtnsComponent} from '../../../modules/widget/components/export-reports-btns/export-reports-btns.component';

@Component({
    selector: 'app-etat-demande',
    templateUrl: './etat-demande.component.html',
    styleUrls: ['./etat-demande.component.css'],
})
export class EtatDemandeComponent implements OnInit {
    @ViewChild(FormGroupDirective) formDirective: FormGroupDirective;
    fields = this.formService.fields;
    CommmCode = CommmCode;
    isPersonnemorale = isPersonnemorale;
    isartisant = isArtisant;
    isPersonnePhysique = isPersonnePhysique;
    isgroupeArisant = isGroupeArtisant;
    isentrprise = isEntrpriseEtrangere;
    public current_lang = this.translate.getDefaultLang();

    public dataacheteur: any;
    public cardacheteur = false;
    public cardF = false;

    generalInfosCard = {
        labels: [
            'Code acheteur public',
            'Nom acheteur public',
            'Type acheteur public',
            'Division',
            'Adresse',
            'Etat déroulement',
            'Motif traitement',
        ],
        dataColumns: {
            ar: [
                'instRegNo',
                'instNmAr',
                'instClNmAr',
                'areaClNmAr',
                'addr1',
                'cdNmAr',
                'excReason',
            ],
            fr: [
                'instRegNo',
                'instNmFr',
                'instClNmFr',
                'areaClNmFr',
                'addr1',
                'cdNmFr',
                'excReason',
            ],
            en: [
                'instRegNo',
                'instNmEn',
                'instClNmEn',
                'areaClNmEn',
                'addr1',
                'cdNmEn',
                'excReason',
            ],
        },
    };

    @ViewChild('exportReportsBtnsComponent') exportReportsBtnsComponent: ExportReportsBtnsComponent;
    icons = icons;
    public key = 'acheteur';
    form = this.formBuilder.group({
        instRcvNo: new FormControl(null),
        instRegNo: new FormControl(),
        nom: new FormControl(),
    });
    formF = this.formBuilder.group({
        categorie: new FormControl(),
        cin: new FormControl(),
        identifiantunique: new FormControl(),
        num_unique_artisan: new FormControl(null, Validators.required),
        date_redac: new FormControl(),
    });
    public data_F: any;

    constructor(
        private toast: ToastService,
        private router: Router,
        private etatService: EtatService,
        private formService: InscriptionfournisseurFormService,
        private formBuilder: FormBuilder,
        public translate: AppTranslateService,
        private translateS: TranslateService
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;
        });
    }

    getFormControl(key) {
        return this.form.get(key) as FormControl;
    }

    ngOnInit(): void {
    }

    reset() {
        this.cardacheteur = false;
        this.form.reset();
        this.formDirective.resetForm();
        this.form.controls['instRcvNo'].enable();
        this.form.controls['instRegNo'].enable();
        // this.searchoptions.emit({})
    }

    resetF() {
        this.cardF = false;

        this.formF.reset();
        this.formDirective.resetForm();
        // this.searchoptions.emit({})
    }

    submitF() {

    }

    get(key: string) {
        return this.formF.get(key) as FormControl;
    }

    setlable() {
        const value = this.formF.get('cin').value;

        if (value == 'cin' && !isEmpty(value)) {
            return 'N° de CIN';
        }
        if (this.isartisant(this.formF.get('categorie').value)) {
            return 'Numéro unique de l\'artisan';
        }
        if (this.isPersonnemorale(this.formF.get('categorie').value)) {
            return 'Matricule fiscal';
        } else {
            return 'Identifiant unique';
        }
    }

    setdate() {
        const value = this.formF.get('cin').value;

        if (
            value == 'cin' &&
            !isEmpty(value || this.isartisant(this.formF.get('categorie').value))
        ) {
            return 'Date de délivrance de carte d\'identité';
        } else {
            return 'Date d\'enregistrement de l\' identifiant unique';
        }
    }

    loadacheteur() {
        const body = {
            instRcvNo: this.form.controls.instRcvNo.value,
            instRegNo: this.form.controls.instRegNo.value,
        };
        /*    if (this.form.invalid) {
          this.toast.error("Numero invalid");
        } else {*/
        this.cardacheteur = true;
        this.etatService.loadcardAcheteur(body).subscribe((response) => {
            this.dataacheteur = response['payload'];

        });

    }

    send(e) {


        this.form.controls['instRcvNo'].setValue(e.value.instRcvNo);
        this.form.controls['instRegNo'].setValue(e.value.instRegNo);
        this.form.controls['instRcvNo'].disable();
        this.form.controls['instRegNo'].disable();
    }

    annuler() {
        this.form.controls['instRcvNo'].enable();
        this.form.controls['instRegNo'].enable();
    }

    detailEtatAcheteur() {
        this.router.navigate([
            '/portail/recapetatachteur',
            this.dataacheteur.instRcvNo,
        ]);
    }

    getFirstCardF() {
        const body = {
            dataSearch: [
                {
                    key: 'bizRegNo',
                    value: this.formF.controls.num_unique_artisan.value,
                    specificSearch: '=',
                },
                {
                    key: 'regModCl',
                    value: 1,
                    specificSearch: '=',
                },
            ],
        };

        if (this.formF.invalid) {
            this.toast.error('Numéro invalide');
        } else {
            this.etatService.loadFirstCardF(body).subscribe((response) => {
                if (response['payload']['total'] == '1') {
                    this.cardF = true;

                    this.data_F = response['payload']['data'][0];
                    /*      const str = this.data_F.addr1.split(",");
                    this.data_F.addr1 =
                      str[0].trim() +
                      ", " +
                      str[1].trim() +
                      ", " +
                      this.data_F.postCd +
                      " " +
                      str[2].trim();*/
                } else {
                    if (response["payload"]["total"] > "1") {
                        const data = response["payload"]["data"]
                        const maxId = Math.max(...data.map(obj => obj.id));

                        this.cardF = true;
                        this.data_F = data.filter(obj => obj.id === maxId)[0];
                    } else {
                        this.cardF = false;
                        this.toast.error("Numéro invalide");
                    }
                }
            });
        }
    }

    detailF() {
        this.router.navigate([
            '/portail/etat/details_info_four',
            this.formF.controls.num_unique_artisan.value,
        ]);
    }
}
